import { Box, Container, Grid, Typography } from '@mui/material';
import hero from '../../assets/orange-b1.png';

export const Page1 = () => {
    return (
        <Container maxWidth={false} sx={{ paddingTop: '20px' }}>
            <Box
                sx={{
                    minHeight: '100vh',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    px: {
                        sx: 1,
                        sm: 2,
                        lg: 5
                    },
                    marginTop: '10px',
                }}
            >
                <Grid
                    container
                    sx={{
                        borderRadius: '36px',
                        overflow: 'hidden',
                        backgroundImage: `url(${hero})`,
                        backgroundSize: 'cover',
                        backgroundPosition: {
                            xs: '75% bottom',
                            sm: '65% center', // Adjusts background image to be 75% towards the right on extra-small screens
                            md: 'center center', // Centers background image on small screens and up
                        },
                        backgroundRepeat: 'no-repeat',
                        minHeight: '80vh',
                        padding: {
                            md: '50px',
                            xs: '20px'
                        },
                        paddingTop: {
                            md: '100px',
                            xs: '20px'
                        },
                        height: '100%', // Ensure the grid takes full height
                    }}
                >
                    <Grid
                        item
                        md={8}
                        xs={7}
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between', // Ensure space between the title and the Explore button
                            minHeight: '100%',
                            height: 'auto',
                            flex: 1,
                        }}
                    >
                        <Typography
                            sx={{
                                fontFamily: 'ClaireMurphy',
                                fontSize: {
                                    xs: '32px', // Font size on extra-small screens
                                    sm: '70px', // Font size on small screens
                                    md: '58px', // Font size on medium screens and larger
                                },
                                fontWeight: 400,
                                lineHeight: '1.4',
                                textAlign: 'left',
                                color: 'rgba(0, 48, 135, 1)',
                            }}
                        >
                            LAVISHA<br /> PROFESSIONAL<br /> HOME CARE
                        </Typography>

                    </Grid>
                </Grid>
            </Box>
        </Container>
    );
};
